<template>
  <div
    id="capture"
    class="inline-flex items-center cursor-pointer"
  >
    <span class="mx-3 text-sm font-medium text-gray-900 whitespace-nowrap">Base Year</span>
    <span
      v-if="isBaseYearLocal"
      @click="handleBaseYear(false)"
    >
      <SwitchOnIcon />
    </span>
    <span
      v-if="!isBaseYearLocal"
      @click="handleBaseYear(true)"
    >
      <SwitchOffIcon />
    </span>
  </div>
</template>

<script>
export default {
  name: 'BaseYearToggle',
  props: {
    isBaseYear: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['base-year'],
  data() {
    return {
      isBaseYearLocal: this.isBaseYear,
    }
  },
  watch: {
    isBaseYear(newVal) {
      this.isBaseYearLocal = newVal
    },
  },
  methods: {
    handleBaseYear(newStatus) {
      this.isBaseYearLocal = newStatus
      this.$emit('base-year', this.isBaseYearLocal)
    },
  },
}
</script>
